interface Props {
	userType: string;
}
export function NotSupportedUserRole(props: Props) {
	return <>
		User with this role {props.userType} is not supported
	</>
}